import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Root from "./pages/root";
import { Provider } from "react-redux";
import store from "./store";
import "focus-visible";
// eslint-disable-next-line
import { iframeResizerContentWindow } from 'iframe-resizer';

const render = element => {
  const el =
    element instanceof HTMLElement ? element : document.querySelector(element);

  ReactDOM.render(
    <Provider store={store}>
      <Root />
    </Provider>,
    el
  );
};

render("#root");

if (module.hot) {
  module.hot.accept("./pages/root", function() {
    render("#root");
  });
}



// WEBPACK FOOTER //
// ./src/index.js